import React from "react";
import { FaSquareWhatsapp } from "react-icons/fa6";

function WhatsAppContact() {
  return (
    <div className="w-contact">
      <a href="https://wa.me/+201098605885" target="_blank" rel="noreferrer">
        <FaSquareWhatsapp />
      </a>
    </div>
  );
}

export default WhatsAppContact;
